import { types } from '../types/types';

export const setError = (error) => {
    return {
        type: types.setError,
        payload: {
            error
        }
    }
}

export const unsetError = () => {
    return {
        type: types.unsetError,
    }
}

export const startLoading = () => {
    return {
        type: types.startLoading,
    }
}

export const finishLoading = () => {
    return {
        type: types.finishLoading,
    }
}

export const startGlobalLoading = () => {
    return {
        type: types.startGlobalLoading,
    }
}

export const finishGlobalLoading = () => {
    return {
        type: types.finishGlobalLoading,
    }
}

export const setMenu = ( menu ) => {
    return {
        type: types.setMenu,
        payload: {
            menu
        }
    }
}

export const toggleSidebar = () => {
    return {
        type: types.toggleSidebar,
    }
}

export const toggleStats = () => {
    return {
        type: types.toggleStats,
    }
}

export const toggleTicketFilters = () => {
    return {
        type: types.toggleTicketFilters,
    }
}

export const openSearchModal = () => {
    return {
        type: types.openSearchModal,
    }
}

export const closeSearchModal = () => {
    return {
        type: types.closeSearchModal,
    }
}

export const setVisibleTicketFilters = (filters) => {
    return {
        type: types.setVisibleTicketFilters,
        payload: {
            filters,
        },
    }
}

export const openTicketCreateModal = () => {
    return {
        type: types.openTicketCreateModal,
    }
}

export const closeTicketCreateModal = () => {
    return {
        type: types.closeTicketCreateModal,
    }
}

export const notifyTicketCreated = () => {
    return {
        type: types.notifyTicketCreated,
        payload: {
            timestamp: Date.now(),
        },
    }
}

export const setVisibleCustomers = (customers) => {
    return {
        type: types.setVisibleCustomers,
        payload: {
            customers,
        },
    }
}

export const setVisibleProjects = (projects) => {
    return {
        type: types.setVisibleProjects,
        payload: {
            projects,
        },
    }
}

export const setVisibleTickets = (tickets) => {
    return {
        type: types.setVisibleTickets,
        payload: {
            tickets,
        },
    }
}

export const setVisibleUsers = (users) => {
    return {
        type: types.setVisibleUsers,
        payload: {
            users,
        },
    }
}

export const setVisibleRecords = (records) => {
    return {
        type: types.setVisibleRecords,
        payload: {
            records,
        },
    }
}

export const openOrFocusTicketTab = (ticket) => {
    return {
        type: types.openOrFocusTicketTab,
        payload: {
            ticket,
        },
    }
}

export const closeTicketTab = (ticketId) => {
    return {
        type: types.closeTicketTab,
        payload: {
            ticketId,
        },
    }
}

export const setActiveTicketTab = (ticketId) => {
    return {
        type: types.setActiveTicketTab,
        payload: {
            ticketId,
        },
    }
}

export const clearTicketTabs = () => {
    return {
        type: types.clearTicketTabs,
    }
}
